import { Box, Heading, List, ListItem, Text } from '@chakra-ui/react';

import React from 'react';

const ProfileTips: React.FC = () => (
  <Box marginX="15px" marginY="10px">
    <Heading as="h2">プロフィール作成のコツについて</Heading>
    <br />
    <Text>リケイマッチをご活用頂き、ありがとうございます！</Text>
    <Text>
      リケイマッチはプロフィールを登録する事で、企業からスカウトが届きます。
    </Text>
    <br />
    <Text>
      プロフィール次第でスカウト受信の可能性も高まるため、このページではプロフィール作成のコツについて記載していきます。
    </Text>
    <Text>
      ※プロフィール画面は開発途上であり、システム仕様が変更することもあります。その際には、本ページも最新の情報に更新いたします。
    </Text>
    <br />
    <List>
      <ListItem>
        <Text fontWeight="semibold">１、画像</Text>
        <Text>画像は自分自身が写り、ハッキリと分かる写真を選びましょう。</Text>
        <Text>
          自分自身の個性が伝わる写真、スーツ着用の写真など自由に設定可能です。
        </Text>
        <Text>
          ※NG例・・・表情がわからない写真。複数名が写って誰が該当するのかわからない写真など。
        </Text>
      </ListItem>
      <br />
      <ListItem>
        <Text fontWeight="semibold">２、学習（タグ）</Text>
        <Text>
          学習（タグ）、学習内容（詳細）は企業がスカウトを送る上で特に重視している内容です。
        </Text>
        <Text>
          履修科目、実験、研究、課外活動など通して学んだことを単語ベースで１つ１つ入力しましょう。
        </Text>
        <Text>※採用活動の裏側ですが、企業は単語で検索をする事も多いです。</Text>
        <br />
        <List>
          <ListItem>
            <Text>■機械関連の単語例</Text>
            <Text>
              熱力学、材料力学、流体力学、機械力学、機械設計、エンジン、ロボット工学、工作機械、旋盤、CAD、3DCAD、AutoCAD、SolidWorks、CATIA、マイクロメータ&emsp;など
            </Text>
          </ListItem>
          <ListItem>
            <Text>■電気電子関連の単語例</Text>
            <Text>
              電気回路、電子回路、パワーエレクトロニクス、制御工学、半導体工学、回路設計、LSI設計、組み込みシステム、CAD、AutoCAD、OrCAD、オシロスコープ&emsp;など
            </Text>
          </ListItem>
          <ListItem>
            <Text>■情報関連の単語例</Text>
            <Text>
              プログラミング、画像処理、人工知能、解析学、オブジェクト志向、組み込みシステム、C言語、Java、Ruby、Python、JavaScript、HTML、React、Laravel、AWS、Linux、MySQL&emsp;など
            </Text>
          </ListItem>
        </List>
      </ListItem>
      <br />
      <Text>
        ※上記はあくまで一例になります。参考にしつつ、独自で学んだことを積極的に記載していきましょう！
      </Text>
      <Text px="9pt">他分野の単語例も随時、作成させていただきます。</Text>
      <br />
      <ListItem>
        <Text fontWeight="semibold">３、学習内容（詳細）</Text>
        <Text>
          学習タグにそって、具体的にどんな学習をしてきたのか記載しましょう。
        </Text>
        <Text>
          実験・実習について記載、得意分野に絞って記載、自主学習について記載するなど書き方は自由です。
        </Text>
        <br />
        <Text>※例文（一例であり、記載方式は自由です）</Text>
        <Text>
          学習で特に力を入れた事は○○です。授業で○○を学び興味を持ったので、それを活かして○○に取り組みました。○○の本やインターネットを利用し作り方を調べ、コツコツと作成しました。今後は○○のスキルを身につけるため、○○についても取り組んでいきます。
        </Text>
      </ListItem>
      <br />
      <ListItem>
        <Text fontWeight="semibold">４、研究内容</Text>
        <Text>
          研究課題、具体的な取り組み、成果・実績、研究を通して学んだことなど記載していきましょう。
        </Text>
        <br />
        <Text>
          研究が始まっていない（決まっていない）場合、研究で学びたいことや研究テーマを選ぶ上で大事にしたいことなど記載していきましょう。
        </Text>
        <Text as="u">
          ※研究が始まった場合は、随時新しい情報へ更新してください。
        </Text>
      </ListItem>
      <br />
      <Text>※例文&emsp;～研究内容が定まっていない場合～</Text>
      <Text>
        〇〇の分野に興味があるため、〇〇○○に取り組む予定です。興味を持った背景は○○○○です。研究活動を通して〇〇について更に深く追求して、将来的には〇〇においても応用できるよう励みたいと思います。
      </Text>
      <br />
      <ListItem>
        <Text fontWeight="semibold">５、学生時代に力を入れたこと</Text>
        <Text>
          アルバイト、部活・サークル、趣味、インターン、課外活動、もしくは学習内容や研究内容で記載しきれなかったことなど何でもOKです。「これだけはがんばった」と言える事を１つ記載しましょう（複数ある場合、書き方はおまかせします）
        </Text>
        <Text>
          「これだけはがんばった」と言える事を１つ記載しましょう（複数ある場合、書き方はおまかせします）
        </Text>
        <br />
        <Text>
          記載例・・・概要、具体的な取り組み、直面した課題、得たこと、学んだこと、今後活かしたいことなど
        </Text>
      </ListItem>
      <br />
      <Text>※例文（一例であり、記載方式は自由です）</Text>
      <Text>
        私が大学生活で力を入れたことは、○○です。具体的な活動内容としては、○○○○になります。私自身、○○に興味があり、○○を目標に掲げて取り組んできました。活動を通して、○○○○の課題に直面する事もありましたが、○○○○を通して解決することができました。最終的には○○を実現することができ、目標であった○○を達成することができました。この体験から○○や○○について得ることができ、就職した後も○○において活かしていきたいと思います。
      </Text>
      <br />
      <ListItem>
        <Text fontWeight="semibold">６、働き方</Text>
        <Text>
          希望職種、希望勤務地、希望企業規模をそれぞれ１つ～３つまで選択できます。希望に合ったスカウトを受信できる確率を高めるため、自分の中で決まっているものがあれば、選択することをお勧めします
        </Text>
        <Text as="u">
          ※一方で、まだ決まっておらず悩まれている場合、決まった後に選択しても大丈夫です。
        </Text>
      </ListItem>
      <br />
    </List>
    <Text>プロフィール作成のコツについて、以上になります。</Text>
    <Text>
      リケイマッチ運営として、理系学生ならではの個性が企業担当へしっかりと伝わるべく、新機能実装や機能改善に取り組んでいきます。それに応じて、このページも随時更新していきたく思います。
    </Text>
    <br />
    <Text>引き続き宜しくお願いいたします。</Text>
    <br />
    <Text>リケイマッチ運営事務局</Text>
  </Box>
);

export default ProfileTips;
